import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/utils/useElement.js";
// 接口配置文件
import "@/api/index.js";

import "../node_modules/wowjs/css/libs/animate.css";
import { WOW } from "wowjs";
Vue.prototype.$wow = WOW;

import VueAwesomeSwiper from "vue-awesome-swiper";
// 包含及小于 Swiper 5.x
import "swiper/css/swiper.css";

Vue.use(VueAwesomeSwiper /* { default options with global component } */);

import MetaInfo from "vue-meta-info";
Vue.use(MetaInfo);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
  mounted() {
    document.dispatchEvent(new Event("render-event"));
  },
}).$mount("#app");
